export default function Features() {
  const features = [
    { icon: '⚡', title: 'Instant Deploy', desc: 'Your token goes live on VDC Chain in under 60 seconds. No waiting, no approval needed.' },
    { icon: '🔥', title: 'Tax System', desc: 'Set buy/sell tax %, choose tax wallet. Tax auto-deducts on every DEX swap.' },
    { icon: '🛡️', title: 'Security Features', desc: 'Blacklist, pause, admin roles, overflow protection built-in by default.' },
    { icon: '⏱️', title: 'Cooldown Period', desc: 'Prevent dump attacks — set time gap between sells on your token.' },
    { icon: '📊', title: 'Min/Max Control', desc: 'Set minimum and maximum buy/sell amounts to control token flow on DEX.' },
    { icon: '🪙', title: 'Mint & Burn', desc: 'Optional mintable and burnable features. Admin can mint, anyone can burn.' },
    { icon: '⏸️', title: 'Emergency Pause', desc: 'Pause all transfers instantly in case of emergency. Resume anytime.' },
    { icon: '💱', title: 'DEX Ready', desc: 'Instantly add liquidity on VDC DEX after deploy. One click redirect.' },
    { icon: '📋', title: 'Full Record', desc: 'ABI, Bytecode, Solidity code all stored. Access anytime from Explore page.' },
  ]

  return (
    <section style={{ padding: '80px 24px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '60px' }}>
        <h2 style={{ fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: '800', marginBottom: '16px' }}>
          Everything You Need to <span className="gradient-text">Launch</span>
        </h2>
        <p style={{ color: '#64748b', fontSize: '16px', maxWidth: '500px', margin: '0 auto' }}>
          Professional token features — no coding, no complexity.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {features.map((f, i) => (
          <div key={i} className="card" style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
            <div style={{
              width: '48px', height: '48px', borderRadius: '12px', flexShrink: 0,
              background: 'linear-gradient(135deg, rgba(124,58,237,0.2), rgba(6,182,212,0.2))',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px'
            }}>{f.icon}</div>
            <div>
              <h3 style={{ fontWeight: '700', marginBottom: '8px', fontSize: '16px', color: '#e2e8f0' }}>{f.title}</h3>
              <p style={{ color: '#64748b', fontSize: '13px', lineHeight: '1.6' }}>{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
